import { config } from "@fortawesome/fontawesome-svg-core";

/**
 * The FontAwesome stylesheet is imported statically in globals.css (inside the
 * `fontawesome` cascade layer). Without this flag svg-core also injects it at
 * runtime, and every icon flashes at its intrinsic 512px before that lands.
 *
 * Imported for side effects only, by ui/Icon.tsx — the one module that compiles
 * into both the server and the client graph, so the flag is set in each.
 */
config.autoAddCss = false;
